import { Text } from '@fable/components'
import { css, cx, useTheme } from '@fable/theme'
import { Element } from 'react-scroll'
import { ClubDetailSectionProps } from 'app/clubs/types'
import { ClubDetailJoinButton } from '../ClubDetailJoinButton'

export const ClubDetailSection = ({
  anchorId,
  className,
  title,
  children,
  note = null,
}: ClubDetailSectionProps) => {
  const { colors, mediaQueries } = useTheme()

  return (
    <Element
      name={anchorId}
      className={cx(
        css`
          width: 100%;
          &:not(:last-child) {
            margin-bottom: 34px;
            padding-bottom: 34px;
            border-bottom: 1px solid ${colors.whiteSmoke};
          }
          ${mediaQueries.tabletL} {
            max-width: 564px;
          }
        `,
        className
      )}
    >
      {!!title ? (
        <Text
          className={css`
            margin-bottom: 24px;
          `}
          tag="h2"
          text={title}
          type="header"
          sizing="XS"
          color={colors.graphite}
        />
      ) : null}
      {children}
      <ClubDetailJoinButton />
      {note}
    </Element>
  )
}
